import styled from 'styled-components';

export const HeaderContainer = styled.div`
	.icon-add-candidate {
		& > path {
			fill: #64778f;
		}
	}
`;

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	margin: 0;

	display: grid;
	grid:
		'header' auto
		'main' 1fr
		'footer' auto
		/ 1fr;

	.modal-icon {
		width: 32px;
		height: 32px;

		& > path,
		g > path {
			fill: #fff;
		}
	}

	.heart-confirmation {
		width: 32px;
		height: 32px;

		& > path {
			fill: #fff;
		}
	}
`;
